import { apiRequest } from '@/shared/api/http'
import { API_BASE_URL } from '@/shared/api/base-url'

// File service (customer/user avatars, updated-customer.md §6; wallet proof documents,
// customer-wallet-rewrite.md §2.4). Upload returns an opaque hashId that is stored on the entity
// (`avatar`, `attachment`) and rendered via the public download URL.
export type FileFolder = 'PUBLIC' | 'CUSTOMER' | 'ORDER' | 'WALLET' | 'PAYMENT' | 'EXPENSE'

export type FileUploadResponse = {
  hashId: string
  fileName: string
  mimeType: string
  size: number
}

export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024 // 10 MB (file service limit)

// Public download URL, usable directly as an <img src>.
export const fileDownloadUrl = (hashId: string) => `${API_BASE_URL}/v1/files/download/${hashId}`

export const filesApi = {
  upload: (file: File, folder?: FileFolder, signal?: AbortSignal) => {
    const formData = new FormData()
    formData.append('file', file)
    if (folder) formData.append('folder', folder)

    return apiRequest<FileUploadResponse>('/v1/files/upload', {
      method: 'POST',
      body: formData,
      signal,
    })
  },
}
